import BaseLayout from '@Containers/Layout/';
import { createBrowserRouter, Navigate } from 'react-router-dom';

import ReportLayout from '@Containers/ReportLayout/ReportLayout';
import CGRScore from './CGRScore';
import EsgGreenhouse from './EsgGreenhouse';
import EsgPlans from './EsgPlans';
import EsgPlatform from './EsgPlatform';
import FinancialStatements from './FinancialStatements';
import GoalAndOperationalPlans from './GoalAndOperationalPlans';
import ImpactsOnStakeholdersManagement from './ImpactsOnStakeholdersManagement';
import Landing from './Landing';
import NatureOfBusiness from './NatureOfBusiness';
import Playground from './Playground';
import Policies from './Policies';
import PreviewPDF from './PreviewPDF/PreviewPDF';
import ProtectRoute from './ProtectRoute';
import ReviewSummaryReport from './ReviewSummaryReport';
import DownloadPage from './DownloadPage/DownloadPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <ProtectRoute>
        <BaseLayout />
      </ProtectRoute>
    ),

    children: [
      {
        path: '',
        element: <Landing />,
      },
      {
        path: 'auth',
      },
      {
        path: 'policies',
        element: <Policies />,
      },
      {
        path: 'report',
        element: <ReportLayout />,
        children: [
          {
            path: '',
            element: <Navigate to="/report/:id/cgr-score" replace />,
          },
          {
            path: ':id/cgr-score',
            element: <CGRScore />,
          },
          {
            path: ':id/nature-of-business',
            element: <NatureOfBusiness />,
          },
          {
            path: ':id/impacts-on-stakeholders-management',
            element: <ImpactsOnStakeholdersManagement />,
          },
          {
            path: ':id/financial-statements',
            element: <FinancialStatements />,
          },
          {
            path: ':id/goals-and-operational-plans',
            element: <GoalAndOperationalPlans />,
          },
          {
            path: ':id/esg-plans',
            children: [
              {
                path: '',
                element: <EsgPlans />,
              },
              {
                path: 'platform',
                element: <EsgPlatform />,
              },
              {
                path: 'greenhouse',
                element: <EsgGreenhouse />,
              },
            ],
          },
          {
            path: ':id/review-summary-report',
            element: <ReviewSummaryReport />,
          },
        ],
      },
      {
        path: 'report/:id/preview',
        element: <PreviewPDF />,
      },
      {
        path: 'playground',
        element: <Playground />,
      },
    ],
  },
  {
    path: 'report/:id/financial-statement-report/:lang/:year',
    element: <DownloadPage />,
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);

export default router;
